export type Language = 'hi' | 'en';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'hi', label: 'हिंदी', flag: '🇮🇳' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export const translations = {
  hi: {
    // App
    appName: 'चौरासिया वर्कशॉप',
    appTagline: 'chaurasiya.shop',
    appCity: 'सीतामढ़ी, बिहार',
    // Nav
    customerView: 'कस्टमर व्यू',
    adminView: 'मालिक (Admin)',
    logout: 'लॉग आउट',
    login: 'लॉगिन करें',
    // Login
    customerLogin: 'कस्टमर लॉगिन',
    adminLogin: 'मालिक (Admin)',
    mobileNumber: '📱 मोबाइल नंबर',
    mobileOrEmail: '📱 मोबाइल नंबर या ईमेल आईडी',
    mobileOrEmailPlaceholder: '10-digit Mobile या name@example.com',
    pin4digit: '🔒 4 अंकों का PIN',
    mobilePlaceholder: '10 अंकों का नंबर',
    pinPlaceholder: 'जैसे: 1234',
    loginBtn: 'लॉगिन करें / आगे बढ़ें →',
    loggingIn: 'लॉगिन हो रहा है...',
    adminPinLabel: '🛡️ Admin PIN',
    adminPinPlaceholder: '4 अंकों का Admin PIN',
    adminLoginBtn: 'Admin पैनल में जाएं →',
    adminNote: '🔧 यह पैनल सिर्फ वर्कशॉप मालिक के लिए है। Admin PIN डालें।',
    demoCredentials: '🎯 Demo Credentials',
    autoFill: 'Auto Fill',
    onlineBookingDiscount: 'ऑनलाइन बुकिंग पर स्पेशल छूट',
    walletBonus: 'वॉलेट रीचार्ज करें और बाइक सर्विस बुक करें — हर रीचार्ज पर 2% बोनस!',
    // Sign Up
    signUp: 'नया रजिस्ट्रेशन',
    createAccount: 'नया अकाउंट बनाएं',
    createAccountSubtitle: 'सभी जानकारी सही भरें',
    fullName: 'पूरा नाम (Full Name)',
    fullNamePlaceholder: 'जैसे: राहुल वर्मा',
    mobileNumberSignup: 'मोबाइल नंबर (10 अंकों का)',
    emailId: 'ईमेल आईडी (Email ID)',
    emailPlaceholder: 'example@gmail.com',
    vehicleNumber: 'गाड़ी नंबर (Vehicle Number)',
    pin4digitSignup: '4-अंकों का सुरक्षा PIN',
    confirmPin: 'PIN दोबारा डालें (Confirm PIN)',
    confirmPinPlaceholder: 'PIN दोबारा डालें',
    registerBtn: 'रजिस्ट्रेशन करें →',
    noAccount: 'नया अकाउंट नहीं है?',
    registerHere: 'यहाँ रजिस्टर करें',
    alreadyAccount: 'पहले से अकाउंट है?',
    loginHere: 'यहाँ लॉगिन करें',
    // Customer Dashboard
    welcome: 'नमस्ते',
    bookService: '🗓️ सर्विस बुक करें',
    bookingHistory: '📋 बुकिंग हिस्ट्री',
    serviceRateCard: '🏷️ सर्विस रेट कार्ड',
    workshopInfo: '📍 वर्कशॉप की जानकारी',
    todaySlots: 'आज के स्लॉट',
    savings: 'बचत',
    // Profile
    profileEmail: 'ईमेल आईडी',
    profileMobile: 'मोबाइल नंबर',
    // Wallet
    walletBalance: 'उपलब्ध वॉलेट बैलेंस',
    recharge: '+ रीचार्ज (+2%)',
    rechargeNote: '*₹100 से ऊपर रीचार्ज पर 2% अतिरिक्त बोनस सीधे वॉलेट में',
    rechargeAmount: 'रकम डालें (₹)',
    // Booking Form
    selectService: 'सर्विस चुनें:',
    bikeNumber: 'बाइक / गाड़ी नंबर:',
    bikeNumberPlaceholder: 'उदा. BR 30 A 1234',
    timeSlot: 'आने का समय (टाइम स्लॉट):',
    bookWithWallet: 'वॉलेट से बुक करें (₹ छूट के साथ)',
    bookingSuccess: '✅ सर्विस सफलतापूर्वक बुक हो गई!',
    bookingSuccessNote: 'तय समय पर वर्कशॉप पहुँचें।',
    anotherBooking: 'दूसरी बुकिंग करें',
    // Admin Dashboard
    adminDashboard: '🔧 मालिक डैशबोर्ड',
    adminSubtitle: 'चौरासिया वर्कशॉप — आज का प्रबंधन',
    overview: 'ओवरव्यू',
    bookings: 'बुकिंग',
    rateManage: 'रेट मैनेज',
    customers: 'कस्टमर',
    inventory: 'स्टॉक',
    reminders: 'रिमाइंडर',
    // Inventory
    spareParts: '🔩 स्पेयर पार्ट्स स्टॉक',
    addPart: '+ पार्ट जोड़ें',
    partName: 'पार्ट का नाम',
    partSKU: 'SKU / बारकोड',
    costPrice: 'खरीद मूल्य (₹)',
    sellPrice: 'बिक्री मूल्य (₹)',
    quantity: 'मात्रा',
    lowStockThreshold: 'कम स्टॉक सीमा',
    lowStock: '⚠️ कम स्टॉक',
    scanQR: '📷 QR/बारकोड स्कैन करें',
    savepart: 'पार्ट सेव करें',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    stockQty: 'स्टॉक',
    // Service Tracker
    serviceTracker: '🚗 सर्विस स्टेटस ट्रैकर',
    trackVehicle: 'गाड़ी नंबर से ट्रैक करें',
    trackBtn: 'ट्रैक करें',
    step_received: 'प्राप्त',
    step_inspection: 'जाँच',
    step_repairing: 'मरम्मत',
    step_washing: 'धुलाई',
    step_ready: 'तैयार',
    // Reminders
    serviceReminders: '🔔 सर्विस रिमाइंडर',
    reminderNote: '60-90 दिन में सर्विस देय वाहन',
    whatsappAlert: 'WhatsApp भेजें',
    daysAgo: 'दिन पहले',
    // Legal Footer
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    refundPolicy: 'Refund & Cancellation',
    contactUs: 'Contact Us',
    footerRights: '© 2026 चौरासिया वर्कशॉप। सर्वाधिकार सुरक्षित।',
    poweredBy: 'Razorpay PCI-DSS Secured Payments',
    close: 'बंद करें',
    // Anti-fraud
    firstServiceDiscount: 'पहली सर्विस डिस्काउंट',
    vehicleAlreadyUsed: '⚠️ यह गाड़ी नंबर पहले ही पहली सर्विस डिस्काउंट ले चुका है।',
    discountApplied: '✅ पहली सर्विस पर 10% डिस्काउंट लागू!',
  },
  en: {
    // App
    appName: 'Chaurasiya Workshop',
    appTagline: 'chaurasiya.shop',
    appCity: 'Sitamarhi, Bihar',
    // Nav
    customerView: 'Customer View',
    adminView: 'Owner (Admin)',
    logout: 'Log Out',
    login: 'Login',
    // Login
    customerLogin: 'Customer Login',
    adminLogin: 'Owner (Admin)',
    mobileNumber: '📱 Mobile Number',
    mobileOrEmail: '📱 Mobile Number or Email ID',
    mobileOrEmailPlaceholder: '10-digit Mobile or name@example.com',
    pin4digit: '🔒 4-Digit PIN',
    mobilePlaceholder: '10-digit number',
    pinPlaceholder: 'e.g. 1234',
    loginBtn: 'Login / Continue →',
    loggingIn: 'Logging in...',
    adminPinLabel: '🛡️ Admin PIN',
    adminPinPlaceholder: '4-digit Admin PIN',
    adminLoginBtn: 'Enter Admin Panel →',
    adminNote: '🔧 This panel is only for the workshop owner. Enter Admin PIN.',
    demoCredentials: '🎯 Demo Credentials',
    autoFill: 'Auto Fill',
    onlineBookingDiscount: 'Special Discount on Online Booking',
    walletBonus: 'Recharge wallet & book bike service — 2% bonus on every recharge!',
    // Sign Up
    signUp: 'New Registration',
    createAccount: 'Create New Account',
    createAccountSubtitle: 'Fill in all details correctly',
    fullName: 'Full Name (पूरा नाम)',
    fullNamePlaceholder: 'e.g. Rahul Verma',
    mobileNumberSignup: 'Mobile Number (10-digit)',
    emailId: 'Email ID (ईमेल आईडी)',
    emailPlaceholder: 'example@gmail.com',
    vehicleNumber: 'Vehicle Number (गाड़ी नंबर)',
    pin4digitSignup: '4-Digit Security PIN',
    confirmPin: 'Confirm 4-Digit PIN (पिन दोबारा डालें)',
    confirmPinPlaceholder: 'Re-enter PIN',
    registerBtn: 'Register →',
    noAccount: "Don\'t have an account?",
    registerHere: 'Register here',
    alreadyAccount: 'Already have an account?',
    loginHere: 'Login here',
    // Customer Dashboard
    welcome: 'Welcome',
    bookService: '🗓️ Book Service',
    bookingHistory: '📋 Booking History',
    serviceRateCard: '🏷️ Service Rate Card',
    workshopInfo: '📍 Workshop Info',
    todaySlots: "Today\'s Slots",
    savings: 'Saved',
    // Profile
    profileEmail: 'Email ID',
    profileMobile: 'Mobile Number',
    // Wallet
    walletBalance: 'Available Wallet Balance',
    recharge: '+ Recharge (+2%)',
    rechargeNote: '*2% extra bonus on recharge above ₹100 directly to wallet',
    rechargeAmount: 'Enter Amount (₹)',
    // Booking Form
    selectService: 'Select Service:',
    bikeNumber: 'Bike / Vehicle Number:',
    bikeNumberPlaceholder: 'e.g. BR 30 A 1234',
    timeSlot: 'Arrival Time (Slot):',
    bookWithWallet: 'Book with Wallet (with ₹ discount)',
    bookingSuccess: '✅ Service booked successfully!',
    bookingSuccessNote: 'Please arrive at the workshop at the scheduled time.',
    anotherBooking: 'Book Another',
    // Admin Dashboard
    adminDashboard: '🔧 Owner Dashboard',
    adminSubtitle: "Chaurasiya Workshop — Today\'s Management",
    overview: 'Overview',
    bookings: 'Bookings',
    rateManage: 'Rate Manage',
    customers: 'Customers',
    inventory: 'Inventory',
    reminders: 'Reminders',
    // Inventory
    spareParts: '🔩 Spare Parts Stock',
    addPart: '+ Add Part',
    partName: 'Part Name',
    partSKU: 'SKU / Barcode',
    costPrice: 'Cost Price (₹)',
    sellPrice: 'Sell Price (₹)',
    quantity: 'Quantity',
    lowStockThreshold: 'Low Stock Threshold',
    lowStock: '⚠️ Low Stock',
    scanQR: '📷 Scan QR/Barcode',
    savepart: 'Save Part',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    stockQty: 'Stock',
    // Service Tracker
    serviceTracker: '🚗 Service Status Tracker',
    trackVehicle: 'Track by Vehicle Number',
    trackBtn: 'Track',
    step_received: 'Received',
    step_inspection: 'Inspection',
    step_repairing: 'Repairing',
    step_washing: 'Washing',
    step_ready: 'Ready',
    // Reminders
    serviceReminders: '🔔 Service Reminders',
    reminderNote: 'Vehicles due for service in 60-90 days',
    whatsappAlert: 'Send WhatsApp',
    daysAgo: 'days ago',
    // Legal Footer
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    refundPolicy: 'Refund & Cancellation',
    contactUs: 'Contact Us',
    footerRights: '© 2026 Chaurasiya Workshop. All rights reserved.',
    poweredBy: 'Razorpay PCI-DSS Secured Payments',
    close: 'Close',
    // Anti-fraud
    firstServiceDiscount: 'First Service Discount',
    vehicleAlreadyUsed: '⚠️ This vehicle number has already used the first service discount.',
    discountApplied: '✅ 10% first service discount applied!',
  },
};

export type TranslationKey = keyof typeof translations.hi;

export function getTranslations(language: Language) {
  return translations[language];
}
